import api from '@/api.ts'
import HttpClient from '@/utils/httpclient'
import _Page from '@/services/Page'

export function overrideFetchPointsByGeohash() {
  if (storelocator.path.id == "internal") {
    api.fetchPointsByGeohash = async (hash) => {
      const params = {}
      const response = await new HttpClient().get(`/internal/api/points/${hash}`, {params}).catch(e => {
        return {status: e.response?.status, data: []}
      })

      return {status: response?.status, data: response?.data}
    }
  }
}


export function overrideFetchPoints() {
  if (storelocator.path.id == "internal") {
    api.fetchPoints = async (params = null) => {
      const response = await new HttpClient().get(`/internal/api/points`, {
        params: params,
        timeout: 20 * 1000 // 長めにしておく、キャッシュや細分化が整ったら短くしてもいい
      }).catch(e => {
        return e
      })

      if (response?.status !== 200) {
        throw new Error('fetchPoints failed', response)
      }

      return {
        status: response?.status,
        data: response?.data
      }
    }
  }
}

// getPointsUrl() を上書き
// 元のコードがpath.idを考慮していないため、URLにpath.idを組み込み
// TODO 各ページのURL取得方法が複数ある?要調査
export function overrideGetPointsUrl() {
  _Page.getPointsUrl = function (area_code = null, params = []) {
    let url = ""
    if (storelocator.path.id) {
      url = `/${storelocator.path.id}`
    }

    url = url + this.baseUrls.points

    const query = this.getForwardQuery()

    if (params.length > 0) {
      query.push(...params)
    }

    const queryString = query.join("&")  
    return url + (area_code ? `areas/${area_code}/` : '') + "points" + (queryString ? `?${queryString}` : "")
  }
}

/**
 * ヘッダー描画、カラーの上書き
 * storelocator.path.id が "internal" の場合のみ
 */
export function overrideHeaderStyle(isInternal = false) {
 if (isInternal) {
  // h1内の画像(src属性)を指定URLに差し替え
  const headerH1Img = document.querySelector("header h1 img")

  if (headerH1Img) {
    headerH1Img.src = "https://storage.googleapis.com/storelocator-v3-static/assets/sne/rogo%20_NE%E7%A4%BE%E5%86%85%E5%85%AC%E9%96%8B%E7%94%A8.png"
  }

  // テーマカラー変更
  const root = document.documentElement
  if (root) {
    root.style.setProperty('--theme-color', '#ef6c00')
    root.style.setProperty('--theme-color-tp05', '#ef6c000d')
  }

  const header = document.querySelector("header")
  if (header) {
    header.style.backgroundColor = "#ef6c0008"
  }

  const footer = document.querySelector("footer")
  if (footer) {
    footer.style.backgroundColor = "#ef6c00"
  }
 }
}